import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import CallAPI from '../../../../adminpanel/components/commonComponents/AxiosHelper';
import LoadingComponent from '../../commonComponents/LoadingComponent';
import OffCanvasComponent from "../../commonComponents/OffCanvasComponent";
import FolderPreview from "../folderView/FolderPreview";
import GridParent from './GridParent';

const TableDetails = ({ authData, match }) => {

    const [renderData, setRenderData] = useState({ isDisplay: false });
    const [currentFolderData, setcurrentFolderData] = useState({});
    let urlParams = match.params;

    useEffect(() => {
        setTimeout(() => {
            feather.replace()
            $('[data-toggle="tooltip"]').tooltip();
        }, 2);
    }, [renderData])

    useEffect(() => {
        getInitialData();
    }, [JSON.stringify(urlParams)]);

    function getInitialData() {
        setRenderData({isDisplay: false})
        if (Object.keys(urlParams).length > 0) {
            let params = { "siteId": authData.siteId, "tableName": `${urlParams.dbName}.${urlParams.tableName}`, "connectionId": urlParams.connectionId };
            CallAPI('get', '/app/get_pulled_file_list', null, params, 0, function (response) {
                if (response.status === true) {
                    setRenderData({ "originalArray": response.information.fileInfo, "actualData": response.information.fileInfo, isDisplay: true });
                } else
                    setRenderData({ "originalArray": [], "actualData": [], isDisplay: true });
            }, authData);
        }
        else {
            let params = { siteId: authData.siteId }
            CallAPI('get', '/app/get_pulled_tables', null, params, 0, function (response) {
                if (response.status === true) {
                    setRenderData({ "originalArray": response.information, "actualData": response.information, isDisplay: true });
                } else
                    setRenderData({ "originalArray": [], "actualData": [], isDisplay: true });
            }, authData);
        }
    }

    function refershButtonEvent(){
        getInitialData()
    }

    const handleSearch = (event) => {
        const target = event.target;
        let tempRenderData = { ...renderData };
        if (target.value.replace(' ', '') === '') {
            setRenderData({ ...tempRenderData, actualData: tempRenderData.originalArray });
        } else {
            const filteredList = renderData.originalArray.filter(singleData => {
                if (singleData.virtualTableName !== undefined) {
                    return singleData['virtualTableName'].toLowerCase().includes(target.value.toLowerCase());
                } else {
                    return singleData['fileName'].toLowerCase().includes(target.value.toLowerCase());
                }
            });
            setRenderData({ ...tempRenderData, actualData: filteredList });
        }
    }

    function folderEvent(folderDetails) {
        setcurrentFolderData(folderDetails);
    }

    let displayData = <h5 className="text-center mg-t-100">
        No Data Exist Add data<br />
        <Link to="/adminpanel/v2/initialize_connector">Click Here</Link> To Add New Connection and load data
    </h5>
    var previewData = <FolderPreview folderData={currentFolderData} authData={authData} countFolder={renderData.actualData ? renderData.actualData.length : null} />;

    if (renderData.isDisplay === false) {
        displayData = <LoadingComponent />
    } else if (renderData.isDisplay && renderData.actualData.length > 0) {
        displayData = <>
            <GridParent renderData={renderData.actualData} folderEvent={folderEvent} getInitialData={getInitialData} urlParams={urlParams} />
            <OffCanvasComponent renderElements={previewData}  topCustomClass={true}/>
        </>
    }

    return (
        <>
            <div className="d-flex">
                <div className="search-form">
                    <input type="search" className="form-control form-control-sm" placeholder="Search" defaultValue="" onChange={handleSearch} />
                    <button className="btn btn-white btn-sm" type="button"><i className="fa fa-search" aria-hidden="true"></i></button>
                </div>
                <button className="btn btn-white btn-sm mg-l-10" type="button" onClick={()=>refershButtonEvent()}>
                    <i className="fa fa-sync" aria-hidden="true"></i>
                </button>
            </div>
            {displayData}
        </>
    )
}

function mapStateToProps(state) {
    return { authData: state.dataSet.authData };
}

export default connect(mapStateToProps, null)(TableDetails);